import React, { useEffect } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import AOS from "aos";

import "./onlineoffline.css";

export default function OnlineOffline() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Navbar />
      <div
        className="mainContentOnlineOffline pt-5"
        data-aos="fade-up"
        data-aos-duration="3000"
      >
        <div className="container">
          <h1 className="text-center text-danger pt-5 fw-bold">
            Offline & Online Distribution
          </h1>
          <div className="pt-3">
            <div className="py-lg-3 fs-5 descriptionOnlineOffline">
              <p className="fs-4 fw-bold">
                Kami akan bantu produk Anda terdistribusi dengan baik disemua
                jaringan pemasaran hingga pelosok Nusantara.
              </p>
              <p>
                Dengan Offline & Online Distribution Service dari Kairos Cahaya
                Cemerlang, kami pastikan produk unggulan Anda hadir di seluruh
                jaringan pemasaran sesuai dengan rencana bisnis Anda. Hubungi
                tim kami untuk diskusi lebih lanjut dan segera maksimalkan
                penjualan produk unggulanmu bersama Kairos Cahaya Cemerlang.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="backgroundColorOfflineDist"
        data-aos="fade-up"
        data-aos-duration="3000"
      >
        <div className="container py-5">
          <h1 className="text-center pb-lg-4">Offline Distribution</h1>
          {/* <div
            id="carouselExampleCaptions"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active d-flex">
                <img src={require("../../assets/offlineDist1.jpg")} alt="..." />
              </div>
              <div class="carousel-item">
                <img src={require("../../assets/offlineDist1.jpg")} alt="..." />
              </div>
              <div class="carousel-item">
                <img src={require("../../assets/offlineDist1.jpg")} alt="..." />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div> */}
          <div class="row row-cols-lg-3 row-cols-sm-2 justify-content-center">
            <div class="col text-center pb-2">
              <img
                src={require("../../assets/offlineDist2.jpg")}
                alt=""
                width={300}
                className="rounded-2"
              />
            </div>
            <div class="col text-center">
              <img
                src={require("../../assets/offlineDist1.jpg")}
                alt=""
                width={350}
                className="rounded-2"
              />
            </div>
            <div class="col text-center">
              <img
                src={require("../../assets/offlineDist3.jpg")}
                alt=""
                width={300}
                className="rounded-2"
              />
            </div>
            <div class="col text-center">
              <img
                src={require("../../assets/offlineDist4.jpg")}
                alt=""
                width={300}
                className="rounded-2"
              />
            </div>
            <div class="col text-center">
              <img
                src={require("../../assets/offlineDist5.jpg")}
                alt=""
                width={300}
                className="rounded-2"
              />
            </div>
          </div>
          <h1 className="text-center py-5">Online Distribution</h1>
          <div>
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Toko Online</h5>

                <p className="card-text">
                  Kita akan bantu memasarkan produk kalian mengguanakan
                  e-commerce 3GINDONESIA.
                </p>
                <a
                  href="https://tokopedia.link/5umXIPJ6Rtb"
                  className="card-link fs-5"
                >
                  Tokopedia
                </a>
                <a
                  href="https://shopee.co.id/kairoscahayacemerlang"
                  className="card-link fs-5"
                >
                  Shoope
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
